export default {
  language: 'currentLanguage',
  authUser: 'authenticatedUser',
};